/**
 * Which prioritization cycle a plan belongs to.
 *
 * A plan cycle has no cycle column. It is governed by the prioritization cycle
 * its input came from — the cycle of its item pool, or of its published
 * priority list — and the database resolves that by join
 * (`plan_cycle_governing_cycle`, migration 843: the same join `authorize_por`
 * uses), never by a matching name. Every page that needs the answer reads it
 * here, so no page can disagree with the act.
 */

import { getTypedSupabaseClient } from './typedSupabaseClient';

/**
 * The cycle's id, or null when the database ties the plan to no cycle (a plan
 * built from a collection, or from an input in another workspace) or the plan
 * could not be read.
 */
export async function fetchPlanGoverningCycleId(planCycleId: string): Promise<string | null> {
  try {
    const { data, error } = await getTypedSupabaseClient().rpc('plan_cycle_governing_cycle', { p_plan_cycle_id: planCycleId });
    return !error && typeof data === 'string' ? data : null;
  } catch {
    return null;
  }
}

/** The same for several plans at once; every id asked for is in the map. */
export async function fetchPlanGoverningCycleIds(planCycleIds: Iterable<string>): Promise<Map<string, string | null>> {
  const ids = [...new Set(planCycleIds)];
  const cycles = await Promise.all(ids.map((id) => fetchPlanGoverningCycleId(id)));
  return new Map(ids.map((id, i) => [id, cycles[i]]));
}
